import React, {useRef, useState} from "react";
import {PictureOutlined, SwapOutlined} from "@ant-design/icons";
import {fileToDataUrl} from "../../services/Helpers";
import styles from "./ApplicationIcon.module.css";

interface ApplicationIconProps {
    onIconChange: (icon: string) => void
    icon?: string
}

export default function ApplicationIcon({onIconChange, icon}: ApplicationIconProps) {
    const inputRef = useRef<HTMLInputElement>(null);
    const [chosen, setChosen] = useState<string>();
    const shown = chosen || icon;

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            fileToDataUrl(file).then(dataUrl => {
                setChosen(dataUrl);
                onIconChange(dataUrl);
            });
        }
        event.target.value = "";
    };

    return (
        <>
            <button
                type="button"
                className={`${styles.frame} ${shown ? "" : styles.frameEmpty}`}
                onClick={() => inputRef.current?.click()}
                aria-label={shown ? "Change app icon" : "Add app icon"}
            >
                {shown
                    ? <img src={shown} alt="" className={styles.image}/>
                    : <span className={styles.placeholder}><PictureOutlined/><span>Add icon</span></span>}
                {shown && <span className={styles.swap} aria-hidden><SwapOutlined/></span>}
            </button>
            <input
                type="file"
                ref={inputRef}
                accept="image/png,image/jpeg,image/svg+xml,image/webp"
                className="display-none"
                onChange={handleFileChange}
            />
        </>
    );
}
